/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Fw_Nav_CharactersInputs */

const en_fw_nav_characters = /** @type {(inputs: Fw_Nav_CharactersInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Characters`)
};

const zh_fw_nav_characters = /** @type {(inputs: Fw_Nav_CharactersInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`角色`)
};

/**
* | output |
* | --- |
* | "Characters" |
*
* @param {Fw_Nav_CharactersInputs} inputs
* @param {{ locale?: "en" | "zh" }} options
* @returns {LocalizedString}
*/
const fw_nav_characters = /** @type {((inputs?: Fw_Nav_CharactersInputs, options?: { locale?: "en" | "zh" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Fw_Nav_CharactersInputs, { locale?: "en" | "zh" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_fw_nav_characters(inputs)
	return zh_fw_nav_characters(inputs)
});
export { fw_nav_characters as "fw.nav.characters" }